import styled from 'styled-components';
import { Molecule } from 'AppReact';
import { GenericWrapper } from 'wrappers';
import { SecondaryTextXs300, SecondaryTextSmBold, Icon } from 'atoms';
import { CornerExpandSvg } from 'components/icons';
import { format } from 'date-fns';
import { formatPrice } from 'utils';

const template = styled.div`
  border-bottom: 1px solid #E3E3E3;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 16px 20px;

  &:hover {
    background-color: #E8F8F0;
  }
`

export default Molecule({
  type: 'button',
  template,
  atoms: [
    {
      wrapper: GenericWrapper,
      name: 'InspectionInfo',
      atoms: [
        {
          component: SecondaryTextSmBold,
          name: 'Template',
          displayValue: ({ inspection }) => {
            return inspection.template ?? inspection.template_name ?? ''
          }
        },
        {
          component: SecondaryTextXs300,
          name: 'Cost',
          displayValue: ({ inspection }) => inspection.has_charges && inspection.total_cost_in_cents !== null ? `Cost: $${formatPrice((inspection.total_cost_in_cents / 100), true)}` : '-'
        },
        {
          component: SecondaryTextXs300,
          name: 'Date',
          displayValue: ({ inspection }) => {
            if (inspection.completion_date) {
              return `Date completed: ${format(new Date(inspection.completion_date), 'MM-dd-yyyy')}`
            }
            if (inspection.cancellation_date) {
              return `Date cancelled: ${format(new Date(inspection.cancellation_date), 'MM-dd-yyyy')}`
            }
            return `Date created: ${format(new Date(inspection.creation_date), 'MM-dd-yyyy')}`
          }
        },

      ]
    },
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ }) => CornerExpandSvg({})
    }

  ]
})